import * as React from "react";
import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentFrequencyOverview } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentFrequencyViews";
export const InsightsReportDeploymentFrequencyHelp = () => (<>
        <CommonInsightsDeploymentFrequencyOverview /> <CommonInsightsReportHelp />
    </>);
